import { Swiper, Navigation } from 'swiper';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

window.addEventListener('load', () => {
  // eslint-disable-next-line no-new
  new Swiper('.testimonials__swiper-container.swiper', {
    modules: [Navigation, HideOffscreenSlides],
    speed: 700,
    slidesPerView: 1,
    spaceBetween: 15,
    loop: true,
    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      enabled: true,
    },
    navigation: {
      nextEl: '.testimonials__nav--next',
      prevEl: '.testimonials__nav--prev',
    },
    autoHeight: true,
  });
});
